import { sanitize } from '../utils/sanitizeText'
import { getURL, baseInteraction, sendEvent } from './utils'

export const TagPushMenu = {
    interactionMenu: (url, text = 'none') => {
        let event = {
            event: 'interaction',
            element_type: 'header:button:click',
            element_content: `none:${sanitize(text)}:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    }
}
